import { FormSubmissionSuccess, trackFormSubmission } from '../../../FrontEndReact/src/Core/Utils/formTracking';
import { getAngularJsService } from '../../../Js/React/Services/legacy';

export function trackPortalFormSubmission({ trackingId }: FormSubmissionSuccess): void {
	try {
		const rootScope = getAngularJsService('$rootScope');
		trackFormSubmission({
			trackingId,
			gtmConfigured: !!rootScope.GetPreloadedPortalSetting('GoogleTagManagerId'),
			statisticsConsent: rootScope.HasAcceptedCookieOfType('statistics') === true,
			marketingConsent: rootScope.HasAcceptedCookieOfType('marketing') === true,
		});
	} catch {
		// This adapter may be unavailable outside the portal host.
	}
}
